export default "__VITE_ASSET__086fe871__"